module.exports = __webpack_public_path__ + "static/img/12.2ae3e2f9.png";